export default __webpack_public_path__ + "icon_owners_manual.f799089bd177b8c2c33fd1ee5cb694cd.svg";